"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.discardRecurrenceDialog = void 0;
var discardRecurrenceDialog = function (props) {
    return optionDialog(props.msg, [{
            text: gettext("Discard all"),
            "class": "btn btn-primary",
            click: props.onDiscardAll
        }, {
            text: gettext("Discard one"),
            "class": "btn btn-secondary",
            click: props.onDiscardOne,
        }], props.onCancel, props.height, props.width);
};
exports.discardRecurrenceDialog = discardRecurrenceDialog;
